import {createAction, handleActions} from 'redux-actions';
import {Api} from '../../api/api';
import {fetchSubmitForm, fetchSubmitFormFailed, fetchSubmitFormSuccess} from "../common/submitForm";
import { logout, onForbidden } from '../account/login';
import {fetchGetAccreditationRequests} from "./accreditationRequests";
import _ from 'lodash';

//- Actions
export const fetchAccreditationRequestByIdFailed = createAction('FETCH_GET_ACCREDITATION_REQUEST_BY_ID_FAILED');
export const fetchAccreditationRequestByIdSuccess = createAction('FETCH_GET_ACCREDITATION_REQUEST_BY_ID_SUCCESS');
export const fetchAccreditationRequestById = createAction(
    'FETCH_GET_ACCREDITATION_REQUEST_BY_ID',
    (id) => Api.getAccreditationRequestById(id),
    () => ({
        apiCall: true,
        onSuccess: fetchAccreditationRequestByIdSuccess,
        onFail: fetchAccreditationRequestByIdFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const onUpdateAccreditationRequest = (id, data, fullUpdateRequired) => (dispatch) => {
    dispatch(fetchSubmitForm());
    dispatch(fetchUpdateAccreditationRequest(id, data, fullUpdateRequired));
};

export const fetchUpdateAccreditationRequest = createAction(
    'FETCH_UPDATE_ACCREDITATION_REQUEST',
    (id, data, fullUpdateRequired) => Api.updateAccreditationRequest(id, data, fullUpdateRequired),
    () => ({
        apiCall: true,
        onSuccess: onEditAccreditationRequestSuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const onRemoveAccreditationRequest = (id) => (dispatch) => {
    dispatch(fetchSubmitForm());
    dispatch(fetchRemoveAccreditationRequest(id));
};

export const onEditAccreditationRequestSuccess = () => (dispatch) => {
    dispatch(fetchSubmitFormSuccess());
    dispatch(fetchGetAccreditationRequests())
};

export const fetchRemoveAccreditationRequest = createAction(
    'FETCH_REMOVE_ACCREDITATION_REQUEST',
    (id) => Api.removeAccreditationRequest(id),
    () => ({
        apiCall: true,
        onSuccess: onEditAccreditationRequestSuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

//- State
const initialState = {
    data: null,
    error: null,
    fetching: false
};

//- Reducers
export default handleActions({
    FETCH_GET_ACCREDITATION_REQUEST_BY_ID: (state) => {
        return {...state, data: null, error: null, fetching: true};
    },
    FETCH_GET_ACCREDITATION_REQUEST_BY_ID_FAILED: (state, action) => {
        return {...state, data: null, error: action.payload, fetching: false};
    },
    FETCH_GET_ACCREDITATION_REQUEST_BY_ID_SUCCESS: (state, action) => {
        return {...state, data: action.payload, error: null, fetching: false};
    }
}, initialState);

//- Selectors
export const getAccreditationRequest = state => state.accreditationRequest;

export const loadingAccreditationRequest = state => getAccreditationRequest(state).fetching;

export const getAccreditationRequestData = state => getAccreditationRequest(state).data;

export const getAccreditationRequestDataFormatted = state => {
    let data = getAccreditationRequestData(state);
    if (_.isNil(data) || !_.has(data, 'accreditationData.titles') || !_.has(data, 'verifiedIdentity')) {
        return null;
    }

    let accreditationRequestData = {
        orgName: data.orgName,
        orgDomain: data.orgDomain,
        accreditationGroupName: data.accreditationGroupName,
        managingOrganizationId: data.managingOrganizationId,
        titleOrig: data.accreditationData.titles.original,
        titleEn: data.accreditationData.titles.en,
        titlesAdditional: {},
        dateIssued: data.accreditationData.issuedAt,
        level: data.accreditationData.level,
        verifiedIdentity: data.verifiedIdentity,
        expose: data.expose
    };

    let additionalTitles = _.pickBy((data.accreditationData.titles), (value, key) => {
        return key !== 'en' && key !== 'original';
    });

    _.mapValues(additionalTitles, (value, key) => {
        accreditationRequestData.titlesAdditional[key] = value;
    });

    return accreditationRequestData;
};



// WEBPACK FOOTER //
// ./src/reducers/applicantAccreditations/accreditationRequest.js